module.exports = __webpack_public_path__ + "static/img/step2_img.d455999.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/TW/img/step2_img.png
// module id = 4JJC
// module chunks = 1